// extracted by mini-css-extract-plugin
export default {"price":"k9-z","onSale":"l9-z","msrpLabelPrice":"m9-z","msrpLabel":"n9-z","originalPrice":"o9-z","percentOff":"p9-z"};